import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
import { Pagination } from '../../../core';
export var LLM_PROVIDER_API = 'LLM_PROVIDER_API';
export var LlmProviderApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(LlmProviderApi, _AxiosApi);

  var _super = _createSuper(LlmProviderApi);

  function LlmProviderApi(axiosInstance, llmProviderMapper) {
    var _this;

    _classCallCheck(this, LlmProviderApi);

    _this = _super.call(this, 'llm-providers', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.llmProviderMapper = llmProviderMapper;
    return _this;
  }

  _createClass(LlmProviderApi, [{
    key: "getLlmProviders",
    value: function () {
      var _getLlmProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var jsonResponse, parsedResponseBody, providers, _iterator, _step, dto, providerResult, paginationResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.get(this.url, {
                  params: {
                    limit: (query === null || query === void 0 ? void 0 : query.limit) || 20,
                    nextToken: query === null || query === void 0 ? void 0 : query.nextToken
                  }
                });

              case 3:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                providers = [];
                _iterator = _createForOfIteratorHelper(parsedResponseBody.data.items);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    dto = _step.value;
                    providerResult = this.llmProviderMapper.toDomain(dto);

                    if (providerResult.isSuccess) {
                      providers.push(providerResult.getValue());
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                paginationResult = Pagination.create({
                  items: providers,
                  nextToken: parsedResponseBody.data.nextToken
                });

                if (!paginationResult.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", Result.fail(paginationResult.error));

              case 11:
                return _context.abrupt("return", Result.ok(paginationResult.getValue()));

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      function getLlmProviders(_x) {
        return _getLlmProviders.apply(this, arguments);
      }

      return getLlmProviders;
    }()
  }]);

  return LlmProviderApi;
}(AxiosApi);